/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationUserSessionIssuersListMcpServers } from "../funcs/organizationUserSessionIssuersListMcpServers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListOrganizationUserSessionIssuerMcpServersRequest,
  ListOrganizationUserSessionIssuerMcpServersResponse,
  ListOrganizationUserSessionIssuerMcpServersSecurity,
} from "../models/operations/listorganizationusersessionissuermcpservers.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type OrganizationUserSessionIssuerMcpServersQueryData =
  ListOrganizationUserSessionIssuerMcpServersResponse;

export type OrganizationUserSessionIssuerMcpServersInfiniteQueryData =
  PageIterator<
    ListOrganizationUserSessionIssuerMcpServersResponse,
    { cursor: string }
  >;

export type OrganizationUserSessionIssuerMcpServersPageParams = PageIterator<
  ListOrganizationUserSessionIssuerMcpServersResponse,
  { cursor: string }
>["~next"];

export function prefetchOrganizationUserSessionIssuerMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListOrganizationUserSessionIssuerMcpServersRequest,
  security?: ListOrganizationUserSessionIssuerMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationUserSessionIssuerMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchOrganizationUserSessionIssuerMcpServersInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListOrganizationUserSessionIssuerMcpServersRequest,
  security?: ListOrganizationUserSessionIssuerMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildOrganizationUserSessionIssuerMcpServersInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam:
      undefined as OrganizationUserSessionIssuerMcpServersPageParams,
    getNextPageParam: (
      previousPage: OrganizationUserSessionIssuerMcpServersInfiniteQueryData,
    ) => previousPage["~next"],
  });
}

export function buildOrganizationUserSessionIssuerMcpServersQuery(
  client$: GramCore,
  request: ListOrganizationUserSessionIssuerMcpServersRequest,
  security?: ListOrganizationUserSessionIssuerMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationUserSessionIssuerMcpServersQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationUserSessionIssuerMcpServers({
      userSessionIssuerId: request.userSessionIssuerId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
    }),
    queryFn: async function organizationUserSessionIssuerMcpServersQueryFn(
      ctx,
    ): Promise<OrganizationUserSessionIssuerMcpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationUserSessionIssuersListMcpServers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildOrganizationUserSessionIssuerMcpServersInfiniteQuery(
  client$: GramCore,
  request: ListOrganizationUserSessionIssuerMcpServersRequest,
  security?: ListOrganizationUserSessionIssuerMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<
      QueryKey,
      OrganizationUserSessionIssuerMcpServersPageParams
    >,
  ) => Promise<OrganizationUserSessionIssuerMcpServersInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationUserSessionIssuerMcpServersInfinite({
      userSessionIssuerId: request.userSessionIssuerId,
      cursor: request.cursor,
      limit: request.limit,
      gramSession: request.gramSession,
    }),
    queryFn: async function organizationUserSessionIssuerMcpServersQuery(
      ctx,
    ): Promise<OrganizationUserSessionIssuerMcpServersInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(
          organizationUserSessionIssuersListMcpServers(
            client$,
            request,
            security,
            mergedOptions,
          ),
        );
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(
        organizationUserSessionIssuersListMcpServers(
          client$,
          {
            ...request,
            cursor: ctx.pageParam.cursor,
          },
          security,
          mergedOptions,
        ),
      );
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyOrganizationUserSessionIssuerMcpServers(
  parameters: {
    userSessionIssuerId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationUserSessionIssuers",
    "listMcpServers",
    parameters,
  ];
}

export function queryKeyOrganizationUserSessionIssuerMcpServersInfinite(
  parameters: {
    userSessionIssuerId: string;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationUserSessionIssuers",
    "listMcpServers",
    "infinite",
    parameters,
  ];
}
